export const MAX_WALLET_ATTEMPTS = 5;
